import type { ProposalDocument } from '@/modules/proposal'

import type { DeliveryBranding } from '../types'
import type { ClientPdfDocument } from './client-pdf-document'
import { compactText } from './client-pdf-document'

export function proposalToClientPdf(
  proposal: ProposalDocument,
  branding?: DeliveryBranding,
): ClientPdfDocument {
  return {
    number: proposal.header.number,
    title: proposal.header.title,
    issuedAtLabel: proposal.header.issuedAtLabel,
    statusLabel: compactText(proposal.header.statusLabel),
    company: {
      name: branding?.companyName || proposal.company.name,
      tagline: branding?.tagline || proposal.company.tagline,
      city: compactText(branding?.city) || compactText(proposal.company.city),
    },
    client: {
      name: proposal.client.name,
      document: compactText(proposal.client.document),
      email: compactText(proposal.client.email),
      phone: compactText(proposal.client.phone),
    },
    items: proposal.items.map((item) => ({
      description: item.detailLines?.length
        ? `${item.name} — ${item.description}\n${item.detailLines.join('\n')}`
        : item.description
          ? `${item.name} — ${item.description}`
          : item.name,
      quantity: item.quantity,
      unitPrice: item.unitPrice,
      lineTotal: item.lineTotal,
    })),
    summary: {
      subtotal: proposal.summary.subtotal,
      discountTotal: proposal.summary.discountTotal,
      shipping: proposal.summary.shipping,
      total: proposal.summary.total,
    },
    terms: {
      payment: compactText(proposal.terms.payment),
      validity: compactText(proposal.terms.validity) || compactText(proposal.header.validityLabel),
      warranty: compactText(proposal.terms.warranty) || compactText(proposal.header.warrantyLabel),
      delivery: compactText(proposal.terms.delivery),
    },
    notes: compactText(proposal.notes),
  }
}
